module.exports = __webpack_public_path__ + "media/country_flags/ir-e2535353.png";